import { request } from '@langlois/request';

export async function activate ({ commit }, {
	paypalSubscriptionId,
	subscriptionId
}) {
	const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription/${subscriptionId}/activate`);

	let response;

	try {
		response = await request.post(url, { paypalSubscriptionId });

		const { ok } = response;

		if (!ok) {
			return commit(`vcl/notificationBar/show`, {
				text: `Encountered an error while activating the subscription.`,
				type: `warning`
			}, { root: true });
		}

		commit(`activate`, {
			id: subscriptionId
		});
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while activating the subscription.`,
			type: `warning`
		}, { root: true });
	}
}
